export const GET_LOSTMEMBER_INFO_LOADING = 'REDUX_SAGA_GET_LOSTMEMBER_INFO_LOADING';
export const LOSTMEMBER_DATA_SUCCESS = 'REDUX_SAGA_LOSTMEMBER_DATA_SUCCESS';
export const LOSTMEMBER_DATA_ERROR = 'REDUX_SAGA_LOSTMEMBER_DATA_ERROR';
export const LOSTMEMBER_DATA_RESET = 'REDUX_SAGA_LOSTMEMBER_DATA_RESET';

export const actionSendEmail = (dispatch, request) => {
    dispatch({ type: GET_LOSTMEMBER_INFO_LOADING, payload: request })
};


export const actionResetSendEmail = (dispatch) => {
    dispatch({ type: LOSTMEMBER_DATA_RESET })
};
